import { Component, OnInit } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AdminService } from '../../../../admin.service';
import { SnackService } from '@shared/services/snack.service';
import { GlossaryService } from '@shared/services/glossary.service';
import { IGlossary } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-glossary-edit',
    templateUrl: './admin-glossary-edit.component.html',
    styleUrls: ['./admin-glossary-edit.component.scss'],
    standalone: false
})
export class AdminGlossaryEditComponent extends AdminActionsDirective implements OnInit {
    formGroup: UntypedFormGroup;

    constructor(
        private glossaryService: GlossaryService,
        private fb: UntypedFormBuilder,
        private snack: SnackService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    ngOnInit(): void {
        this.buildForm();
    }

    private buildForm() {
        this.formGroup = this.fb.group({
            id: this.item.id,
            title: [this.item.title, Validators.required],
            description: [this.item.description, Validators.required],
            titleDe: this.item.titleDe,
            descriptionDe: this.item.descriptionDe
        });
    }

    get item(): IGlossary {
        return this.selectedItem;
    }

    async updateItem(event: any): Promise<void> {
        this.disableSubmitter(event);
        if (this.formGroup.valid) {
            try {
                const result = await this.glossaryService.updateItem(this.formGroup.value);
                this.snack.openSnackBarSuccess(`Glossary item ${result.id} updated successfully.`);
                this.goToGlossaryItem(result);
            } catch (e) {
                this.snack.openSnackBarError(e.error.message);
            }
        } else {
            this.snack.openSnackBarError('Please check your input.');
        }
        this.enableSubmitter(event);
    }
}
